import {EUISAPConnections} from '../actions/sap-actions';
export const initialSAPState: ISAPCPState = {
  destinations: null,
  sapConfiguration: "",
  sapConfigurations: []
};

export function SAPReducer(state = initialSAPState, action: any): ISAPCPState {
  switch (action.type) {

    case EUISAPConnections.GetAllDestinationsSuccess : {
      const newState = {...state, destinations: action.payload};
      return newState;
    }
    case EUISAPConnections.UpdateSAPCPConfigurationSuccess : {
      const newState = {...state, sapConfiguration: action.payload};
      return newState;
    }
    case EUISAPConnections.GetSAPConfigurationsSuccess : {
      const newState = {...state, sapConfigurations: action.payload};
      return newState;
    }
    default: {
      return state;
    }
  }
}


